/**
 * 站点内容数据 —— 公司官网文案统一管理
 * 便于后续接入 CMS 或接口时替换。
 */

export const SITE = {
  name: '灵芝网络',
  nameEn: 'LZNetwork',
  companyName: '镇江灵芝网络科技有限公司',
  slogan: '专业增值电信，可靠互联服务',
  description:
    '镇江灵芝网络科技有限公司专业经营增值电信业务，致力于为企业客户提供合规、可靠、高效的互联网信息服务。',
  /** 工商登记主体信息 */
  legal: {
    creditCode: '91321111MA1P3H952L',
    legalPerson: '高强',
    registeredCapital: '50万(元)',
    foundedAt: '2017-05-27',
    address: '镇江市润州区溪园新村18幢4单元206室',
    businessScope:
      '经营增值电信业务（不含新闻、出版、教育、医疗保健、药品和医疗器械的互联网信息服务）。',
  },
  contact: {
    /** 官方联系方式（无座机，以邮箱为主） */
    email: '15895951398@139.com',
    address: '镇江市润州区溪园新村18幢4单元206室',
    wechat: 'LZNetwork',
  },
  socials: [
    { label: '官方网站', href: 'https://www.lznetwork.cn' },
    { label: '微信公众号', href: '#' },
    { label: '邮箱联系', href: 'mailto:15895951398@139.com' },
  ],
} as const

/** 核心服务（贴合增值电信业务经营范围） */
export const SERVICES = [
  {
    icon: 'cloud',
    title: '互联网信息服务',
    description: '依法提供互联网信息服务业务，为企业客户搭建合规、稳定的信息发布与内容服务平台。',
    tags: ['ICP 服务', '信息发布', '内容平台'],
  },
  {
    icon: 'data',
    title: '在线数据处理与交易',
    description: '提供在线数据处理与交易处理业务服务，支持企业开展安全、高效的线上业务运营。',
    tags: ['数据处理', '交易处理', '线上运营'],
  },
  {
    icon: 'shield',
    title: '安全与合规服务',
    description: '围绕增值电信业务，提供信息安全与合规保障，助力企业合规开展互联网经营。',
    tags: ['信息安全', '合规经营', '增值电信'],
  },
  {
    icon: 'terminal',
    title: '技术开发与运维',
    description: '提供配套的技术开发与运行维护支持，保障企业互联网服务持续稳定运行。',
    tags: ['技术开发', '运行维护', '稳定可靠'],
  },
] as const

/** 服务优势（贴合增值电信业务） */
export const ADVANTAGES = [
  {
    icon: 'shield',
    title: '资质合规',
    description: '持证经营增值电信业务，手续齐备，合作安心。',
  },
  {
    icon: 'cloud',
    title: '稳定可靠',
    description: '完善的运行维护体系，保障服务持续稳定。',
  },
  {
    icon: 'heart',
    title: '服务用心',
    description: '专业团队贴心响应，助力业务顺利开展。',
  },
] as const

/** 数据指标（基于真实经营情况） */
export const STATS = [
  { value: '2017', label: '公司成立' },
  { value: '50万', label: '注册资本' },
  { value: '增值电信', label: '持证经营' },
  { value: '镇江市', label: '注册地' },
] as const
